import * as React from "react";
import { env as s$1 } from "../utils/env.js";
function s() {
  let r = typeof document == "undefined";
  return "useSyncExternalStore" in React ? ((o) => o.useSyncExternalStore)(React)(() => () => {
  }, () => false, () => !r) : false;
}
function l() {
  let r = s(), [e, n] = React.useState(s$1.isHandoffComplete);
  return e && s$1.isHandoffComplete === false && n(false), React.useEffect(() => {
    e !== true && n(true);
  }, [e]), React.useEffect(() => s$1.handoff(), []), r ? false : e;
}
export {
  l as useServerHandoffComplete
};
